import Axios from "../common/axios"

export enum Type {
    WAITING = "ChargeStatus.FETCH_WAITING"
    , COMPLETED = "ChargeStatus.FETCH_COMPLETED"
    , ERROR = "ChargeStatus.FETCH_ERROR"
}

export interface Action {
    type: Type
    payload: any
}

export const fetch = () => async (dispatch: (action: Action) => Action, getState: () => any) => {
    const state = getState().chargeStatus

    if (state.loading || state.fetched) {
        return
    }

    const uri = "/api/charge-status"
    const cache = sessionStorage.getItem(uri)

    if (cache) {
        return dispatch({ type: Type.COMPLETED, payload: { data: JSON.parse(cache) } })
    }

    dispatch({ type: Type.WAITING, payload: {} })

    try {
        const { data, request } = await Axios.get(uri, {})

        if (request.responseURL.endsWith("/login")) {
            throw new Error("redirected to /login")
        }

        sessionStorage.setItem(uri, JSON.stringify(data))
        dispatch({ type: Type.COMPLETED, payload: { data } })
    } catch (error) {
        dispatch({ type: Type.ERROR, payload: { error } })
    }
}

export interface ChargeStatusState {
    loading: boolean
    fetched: boolean

    data: any[]
}

const reducer = (prevState: ChargeStatusState, action: Action): ChargeStatusState => {
    const state = { ...prevState }

    switch (action.type) {
        case Type.WAITING:
            state.loading = true
            break
        case Type.COMPLETED:
            state.loading = false
            state.fetched = true

            const { data } = action.payload.data

            state.data = [...data]
            break
    }

    return state
}

export default reducer